import React from 'react'
import './services.css';

const ServicesComponent = () => {
    var clientScreenSize = document.body.clientWidth

    return (
        <div className='serviceContainer' id='solutions'>
            <div className='serviceHeading'>
                Solutions
            </div>
            <div className='serviceFlex'>
                <div className='serviceLeftFlex'>

                    <div style={{fontSize:'42px',color:'var(--logo-color)',fontWeight:800}}>
                        Advertisers
                    </div>
                    <br/>
                    <div className='solutionsText'>
                        We facilitate a growing network of performing Publishers that will help advertisers reach customers with actual installs instead of clicks or impressions.
                        <br/>
                        <br/>
                        Alongwith this, we can engage mobile users all over the world with carefully selected publishing partners.
                        <ul style={{marginLeft:'0px'}}>
                        <li>Data-Driven Analysis</li>
                        <li>AI Based Optimization</li>
                        <li>Fraud Detection Tools</li>
                        <li>Advanced Targeting</li>
                        <li>Direct Publishers</li>
                        </ul>
                    </div>
                </div>
            </div>
            <br/>
            <br/>
            <div className='serviceFlex'>
                {clientScreenSize>800
                &&
                <div className='serviceLeftFlex'>

                </div>
                }
                <div className='serviceRightFlex'>
                    <div style={{fontSize:'42px',color:'var(--logo-color)',fontWeight:800}}>
                        Publishers
                    </div>
                    <br/>
                    <div className='solutionsText'>
                        We offer smart monetization solutions for Publishers traffic through a wide choice of global offers in CPI, CPA, CPL, CPS, CPR models and in different verticals.
                        <br/>
                        <br/>
                        We have an easy to understand platform designed for your success that offers quick integration and on-time flexible payment methods.
                        <ul style={{marginLeft:'0px'}}>
                        <li>Top Converting Offers</li>
                        <li>On-Time High Payouts</li>
                        <li>Android/iOS Campaigns</li>
                        <li>Different Ad-Formats</li>
                        <li>Smart Campaign Links</li>
                        <li>Real Time Statistics</li>
                        </ul>
                    </div>
                </div>
            </div>
            <br/>
            <br/>
            <div className='serviceFlex'>
                <div className='serviceLeftFlex'>

                    <div style={{fontSize:'42px',color:'var(--logo-color)',fontWeight:800}}>
                        Developers
                    </div>
                    <br/>
                    <div className='solutionsText'>
                        We help Developers to work with an impressive amount of direct advertisers and top mobile agencies globally.
                        <br/>
                        <br/>
                        Developers can integrate our studio ads inside their apps also.
                        <ul style={{marginLeft:'0px'}}>
                            <li>Performance Delivery</li>
                            <li>Right Audience Targeting</li>
                            <li>Tracking & Reporting</li>
                            <li>Multiple Verticals Traffic</li>
                            <li>Reliable Payments</li>
                            <li>Flexible Integration</li>
                        </ul>
                    </div>
                </div>
            </div>
            
            
            
        </div>
    )
}

export default ServicesComponent